import { render, staticRenderFns } from "./AdminTablePagination.vue?vue&type=template&id=6b71c1b7&"
import script from "./AdminTablePagination.vue?vue&type=script&lang=js&"
export * from "./AdminTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./AdminTablePagination.vue?vue&type=style&index=0&land=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports